<template>
  <div class="demand_index">
    <TemplateDemandIndex
      v-if="isReadyToDraw"
      :demand-area="demandArea"
      :reservations="Reservations"
    />

    <!-- index画面の描画ローディング -->
    <ItemDialogForIndexPage v-else />
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import API from "@/API";
import TemplateDemandIndex from "@/views/Templates/Demand/TemplateDemandIndex";
import { useStore } from "vuex";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "DbsIndex",
  components: {
    TemplateDemandIndex,
  },
  setup() {
    const store = useStore();
    const isReadyToDraw = ref(false);

    const demandArea = ref(null);
    const Reservations = ref([]);

    onMounted(async () => {
      console.log("nativeHandlerService :>> ", nativeHandlerService);
      nativeHandlerService.demand.ncSetDemandIndex(0);

      // 予約可能なサービス一覧の取得
      demandArea.value = await API.getDemandArea();

      // ログインしてたら予約一覧取得
      // デマンド予約一覧取得
      if (store.getters["common/isLogin"]) {
        Reservations.value = await API.getDemandReservations(false);
      }

      isReadyToDraw.value = true;
    });

    return {
      isReadyToDraw,
      demandArea,
      Reservations,
    };
  },
};
</script>

<style scoped lang="scss">
.demand_index {
  height: 100vh;
  background: #f9f9f9;
}
</style>
